import React from "react";
import { FileText, Download, Calendar, TrendingUp, BarChart3, PieChart, Building2, Users } from "lucide-react";

const REPORTS = [
  { id: "monthly-intelligence",  title: "Intelligence Report — Mensile",     desc: "Sintesi mensile OSINT/SOCMINT/HUMINT su tutte le entità monitorate", icon: BarChart3, updated: "18 lug 2026", size: "2.4 MB" },
  { id: "supplier-risk",         title: "Supplier Risk Radar",                 desc: "Health score fornitori con delta trimestrali, KYC compliance e sanctions screening", icon: TrendingUp, updated: "17 lug 2026", size: "1.8 MB" },
  { id: "sales-pipeline",        title: "Sales Pipeline Snapshot",             desc: "Fotografia CRM: opportunità aperte, deal in chiusura, alert commerciali", icon: PieChart, updated: "15 lug 2026", size: "980 KB" },
  { id: "business-network",      title: "Business Intelligence Network",       desc: "Panorama aziende e persone salvate, verifica identità, tech stack", icon: Building2, updated: "16 lug 2026", size: "3.1 MB" },
  { id: "people-network",        title: "People Watch — Executive Report",    desc: "Movimenti chiave, cambi di ruolo, seniority mapping per key accounts", icon: Users, updated: "14 lug 2026", size: "1.2 MB" },
  { id: "framework-quarterly",   title: "Framework Contestuale — Q3 2026",    desc: "Aggiornamenti normativi doganali, fiscali, commerciali e gare in corso", icon: FileText, updated: "10 lug 2026", size: "4.6 MB" },
];

export default function Reportistica() {
  return (
    <div className="p-6 sm:p-8 space-y-6">
      <div>
        <div className="inline-flex items-center gap-2 mb-2 text-[10px] tracking-[0.25em] uppercase text-[#0891B2] font-bold">
          <FileText className="w-3 h-3" strokeWidth={1.6} /> Reportistica
        </div>
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight" style={{ fontFamily: "Chivo, sans-serif" }}>
          Report periodici
        </h1>
        <p className="text-sm mt-1 max-w-2xl" style={{ color: "#475569" }}>
          Scarica report esecutivi pronti per il tuo CdA — sintesi periodiche di Intelligence, KYC, pipeline commerciale, supply chain e normativa.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {REPORTS.map(r => (
          <div key={r.id} data-testid={`report-card-${r.id}`}
               className="bg-[#F8FAFC] border border-white/[0.04] rounded-lg p-5 flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-md border border-[#0891B2]/40 bg-[#0891B2]/10 flex items-center justify-center flex-shrink-0">
                <r.icon className="w-5 h-5 text-[#0891B2]" strokeWidth={1.6} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-bold text-slate-800 leading-tight" style={{ fontFamily: "Chivo, sans-serif" }}>{r.title}</h3>
                <p className="text-[10px] tracking-widest uppercase text-slate-500 mt-1 flex items-center gap-1">
                  <Calendar className="w-2.5 h-2.5" /> {r.updated} · {r.size}
                </p>
              </div>
            </div>
            <p className="text-xs text-slate-600 leading-relaxed mb-4 flex-1">{r.desc}</p>
            <button
              data-testid={`report-download-${r.id}`}
              onClick={() => alert(`Report "${r.title}" — generazione PDF non ancora attiva. Endpoint /api/reports/${r.id}/pdf da implementare.`)}
              className="inline-flex items-center justify-center gap-2 bg-[#0891B2] text-white px-4 py-2 rounded-md text-xs font-bold uppercase tracking-widest hover:bg-[#155E75] transition-colors"
            >
              <Download className="w-3.5 h-3.5" /> Scarica PDF
            </button>
          </div>
        ))}
      </div>

      <p className="text-[10px] tracking-widest uppercase text-slate-400 text-center mt-6">
        Report generati automaticamente da MOONSTONE · Dati aggiornati in tempo reale
      </p>
    </div>
  );
}
